import type { TOC } from '@ember/component/template-only';
import PageError from '../../components/page-error.gts';

interface Signature {
  Args: {};
}

const SourcesShowError: TOC<Signature> = <template>
  <PageError
    @title="Failed to load source"
    @backRoute="sources"
    @backLabel="Back to my sources"
  />
</template>;

export default SourcesShowError;
